import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import { translate } from '../Services/translation';
import { useDispatch, useSelector } from "react-redux";
import { doShowResult, query as runQuery, selectOrganization, setSearchQuery } from "../Actions/OrganizationSearch.action";
import { Svg } from "./Svg";
const AdditionalOrgsResultItem = ({ qtyOverInitial }) => {
    let text = translate('nmas.login.selectorganization.results.info.item');
    text = text.replace('{x}', qtyOverInitial);
    return _jsx(TextResultItem, { children: text });
};
const TextResultItem = ({ children }) => {
    return (_jsx("li", { className: 'select-organization-result__more-orgs-item no-hover', children: children }));
};
const OrganizationSearchResults = () => {
    const dispatch = useDispatch();
    const initialShow = 5;
    const { query, result, showResult, selectedItem, redirectUrl } = useSelector(state => state.organizationSearch);
    let decodedQuery = decodeURIComponent(query);
    let splitQuery = decodedQuery.split(/\s+/).map(x => x.toLowerCase().trim()).filter(Boolean);
    let resultsToShow = result;
    if (result.length && query && query.length) {
        resultsToShow = resultsToShow.filter(res => {
            return splitQuery.every(sq => res.name.toLowerCase().includes(sq) ||
                res.address3.toLowerCase().includes(sq) ||
                res.address4.toLowerCase().includes(sq));
        })
            .sort((a, b) => {
            var aStarts = a.name.toLowerCase().startsWith(decodedQuery);
            var bStarts = b.name.toLowerCase().startsWith(decodedQuery);
            if (aStarts && !bStarts)
                return -1;
            if (!aStarts && bStarts)
                return 1;
            var aIncludes = a.name.toLowerCase().includes(decodedQuery);
            var bIncludes = b.name.toLowerCase().includes(decodedQuery);
            if (aIncludes && !bIncludes)
                return -1;
            if (!aIncludes && bIncludes)
                return 1;
            return 0;
        });
    }
    let moreThanInitial = query.length <= 0 && resultsToShow.length > initialShow;
    let qtyOverInitial = resultsToShow.length - initialShow;
    if (moreThanInitial) {
        resultsToShow = resultsToShow.slice(0, initialShow);
    }
    return (showResult && resultsToShow.length !== 0 ? (_jsx(_Fragment, { children: _jsx("div", { className: "select-organization-result__result-wrapper", children: _jsxs("ul", { className: "select-organization-result__result", children: [resultsToShow &&
                        resultsToShow.map((item, index) => (_jsx("li", { className: `select-organization-result__result__item ${selectedItem === index
                                ? 'select-organization-result__result__item--selected'
                                : ''}`, children: _jsx("a", { className: `select-organization-result__result__link`, onClick: () => dispatch(selectOrganization(item.id, redirectUrl ? redirectUrl : '/')), children: _jsx("div", { children: [_jsx("strong", { children: item.name }), item.address3, item.address4]
                                        .filter(Boolean)
                                        .reduce((acc, cur, i) => acc.concat(i > 0 ? [' - ', cur] : [cur]), []) }) }) }, `${item.name}-${index}`))), moreThanInitial && (_jsx(AdditionalOrgsResultItem, { qtyOverInitial }))] }) }) })) : showResult && resultsToShow.length === 0 ? (_jsx("span", { className: `select-organization-result__result__link`, children: _jsx(TextResultItem, { children: translate('nmas.search.nohit') }) })) : null);
};
const OrganizationSearch = (props) => {
    const dispatch = useDispatch();
    const searchInputRef = useRef();
    const clearSearchRef = useRef();
    const { query, result, showResult, } = useSelector(state => state.organizationSearch);
    /**
     * @param {MouseEvent} e
     * @returns {boolean|null}
     */
    const onBlur = (e) => {
        let parentElement = document.querySelector('#organizationSearch');
        if (!parentElement)
            return null;
        let targetWithInParent = parentElement === e.target || parentElement.contains(e.target) || clearSearchRef.current === e.target;
        !targetWithInParent && dispatch(doShowResult(false));
    };
    useEffect(() => {
        dispatch(runQuery());
    }, []);
    useEffect(() => {
        setTimeout(() => {
            searchInputRef.current && searchInputRef.current.focus();
        }, 0);
        document.addEventListener('click', onBlur);
        return () => document.removeEventListener('click', onBlur);
    }, [result]);
    if (!result) {
        return _jsx(_Fragment, {});
    }
    return (_jsxs("div", { className: `select-organization ${(showResult ? 'results-open' : '')}`, children: [_jsx("h3", { className: "select-organization__title", style: { marginLeft: '1.5rem' }, children: translate('nmas.login.selectorganization') }), _jsxs("div", { className: "select-organization__search", role: "search", children: [_jsxs("div", { className: `select-organization__search__form`, role: "search", children: [_jsx("input", { className: "select-organization__search__input form__input", type: "text", placeholder: translate('general.search'), autoComplete: "off", value: decodeURIComponent(query), onFocus: () => dispatch(doShowResult(true)), onChange: e => dispatch(setSearchQuery(encodeURIComponent(e.target.value))), ref: searchInputRef }), ((showResult && query.length <= 0) || !showResult) && _jsx("span", { children: _jsx(Svg, { icon: 'magnifying-glass' }) }), showResult && query.length > 0 && _jsx("span", { onClick: () => {
                                    dispatch(setSearchQuery(''));
                                }, ref: clearSearchRef, children: _jsx(Svg, { icon: 'close' }) })] }), _jsx("div", { className: "select-organization-result__container", children: _jsx(OrganizationSearchResults, {}) })] })] }));
};
export default OrganizationSearch;
